/**
 * Formata uma data de forma inteligente:
 * - Hoje às HH:MM
 * - Ontem às HH:MM
 * - Anteontem às HH:MM
 * - DD/MM/YYYY, HH:MM (para datas mais antigas)
 */
export const formatarDataInteligente = (data) => {
  if (!data) return '-';
  
  const dataObj = new Date(data);
  const hoje = new Date();
  
  // Zerar horas para comparação de dias
  const hojeSemHora = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  const dataSemHora = new Date(dataObj.getFullYear(), dataObj.getMonth(), dataObj.getDate());
  
  // Calcular diferença em dias
  const diferencaDias = Math.floor((hojeSemHora - dataSemHora) / (1000 * 60 * 60 * 24));
  
  // Formatar hora
  const hora = dataObj.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  });
  
  if (diferencaDias === 0) {
    return `Hoje às ${hora}`;
  } else if (diferencaDias === 1) {
    return `Ontem às ${hora}`;
  } else if (diferencaDias === 2) {
    return `Anteontem às ${hora}`;
  } else {
    return dataObj.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
};

/**
 * Formata uma data sem hora de forma inteligente:
 * - Hoje
 * - Ontem
 * - Anteontem
 * - DD/MM/YYYY (para datas mais antigas)
 */
export const formatarDataSemHora = (data) => {
  if (!data) return '-';
  
  const dataObj = new Date(data);
  const hoje = new Date();
  
  // Zerar horas para comparação de dias
  const hojeSemHora = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  const dataSemHora = new Date(dataObj.getFullYear(), dataObj.getMonth(), dataObj.getDate());
  
  // Calcular diferença em dias
  const diferencaDias = Math.floor((hojeSemHora - dataSemHora) / (1000 * 60 * 60 * 24));
  
  if (diferencaDias === 0) {
    return 'Hoje';
  } else if (diferencaDias === 1) {
    return 'Ontem';
  } else if (diferencaDias === 2) {
    return 'Anteontem';
  } else {
    return dataObj.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
};
